export default "__VITE_ASSET__CH7pB$$L__"